import { render, staticRenderFns } from "./OrgDetails.vue?vue&type=template&id=aabd7a3e&scoped=true&"
import script from "./OrgDetails.vue?vue&type=script&lang=js&"
export * from "./OrgDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrgDetails.vue?vue&type=style&index=0&id=aabd7a3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabd7a3e",
  null
  
)

export default component.exports